import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';

import {
  IDwelling,
  IDwellingInput,
  IOptions,
  IOptionSets,
  IUser
} from '@ebb-v2/ebb-integration';
import { ApplicationEventApiService, DwellingApiService, OptionSetsApiService, AuthenticationService } from '../../data-services';
import { DialogWithdrawComponent, DialogWithdrawData } from '../dialog/dialog-withdraw.component';

@Component({
    selector: 'ebb-portal-dwelling-qualified-list',
    templateUrl: './dwelling-qualified-list.component.html',
    standalone: false
})
export class DwellingQualifiedListComponent implements OnInit {
  @Input() data: IDwelling[] = [];
  @Input() currentUser: IUser;
  @Input() textHomeownerDwellingQualified: string;
 
  public withdrawOptions: IOptionSets[] = [];
  public WithdrawEventTypeOptions: IOptions[] = {} as IOptions[];
  public WithdrawTypeOptions: IOptions[] = [];
  public OtherWithdrawOption: IOptions = {} as IOptions;
  constructor(
    private readonly router: Router,
    private readonly dialogWithdraw: MatDialog,
    private readonly apiOptionSets: OptionSetsApiService,
    private readonly apidwelling: DwellingApiService,
    private readonly authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.loadAppEventOptionsData();
  }

  private loadAppEventOptionsData(): void {
    const that = this;
    that.apiOptionSets.getList('applicationevent').subscribe(data => {
        that.withdrawOptions = data;
        const indexeventOptions = that.withdrawOptions.findIndex(i => i.name === 'cea_event_type');
        that.WithdrawEventTypeOptions = [...that.withdrawOptions[indexeventOptions].options];


      }, error => console.warn(error));
  }
  /**********************************************
   * Withdraw Application
   */
  public onWithdrawEvent(dwelingId: string): void {
      const that = this;
      const dialogWithdrawItem: DialogWithdrawData = {} as DialogWithdrawData;
      const withdrawfilteroptions = that.WithdrawEventTypeOptions.filter(
        x => x.label.startsWith('Withdraw')
      );
      const otherwithdrawOptions = {} as IOptions;
      const WithdrawTypeOptions: IOptions[] = [];
      withdrawfilteroptions.forEach(function(option) {
        const withdrawOptions = {} as IOptions;
        const label = option.label.replace('Withdraw : ', '');
        if (label.startsWith('Other')) {
          otherwithdrawOptions.value = option.value;
          otherwithdrawOptions.label = label;
        } else {
          withdrawOptions.label = label;
          withdrawOptions.value = option.value;
          WithdrawTypeOptions.push(withdrawOptions);
        }
      });
      WithdrawTypeOptions.push(otherwithdrawOptions);
      dialogWithdrawItem.reasonoptions = WithdrawTypeOptions;
      that.WithdrawTypeOptions = WithdrawTypeOptions;
    dialogWithdrawItem.title =
      'Are you sure you want to remove your home from the selection process? To activate your application later please call customer support.';
    const dialogRef = that.dialogWithdraw.open(DialogWithdrawComponent, {
      width: '400px',
      data: dialogWithdrawItem
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const dwelling: IDwellingInput = {} as IDwellingInput;
        dwelling.stateCode = 1;
        dwelling.statusCode = 2;
const reason = that.WithdrawTypeOptions.find(x=>x.value=== dialogWithdrawItem.reason).label;
        if (dialogWithdrawItem.otherreason){
dwelling.withdrawReason =reason + ':' + dialogWithdrawItem.otherreason;
        }else{
          dwelling.withdrawReason = reason;
        }

        that.apidwelling
          .withdrawDwelling(dwelling, dwelingId)
          .subscribe(
            data => {
              // this.router.navigate(['home']);
              window.location.reload();
            },
            err => console.warn(`ERROR:onWithdrawEvent() - ${err}`)
          );
      }
    });
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
